define('views/components/timeline/timeline_block',['require','backbone','text!templates/components/timeline/timeline_block.html'],function(require){

    var Backbone = require('backbone');

    var temp = require("text!templates/components/timeline/timeline_block.html");
    return Backbone.Marionette.ItemView.extend({
        tagName: 'div',
        template: _.template(temp),
        className: 'timeline-block 2',
        initialize: function(options) {

            this.on('render', this.afterRender);
            
        },   
        afterRender: function(){
        }
        
    });
});
